import { LOCALE_DEFAULT } from '@model/const/locales';

export default {
    computed: {
        isPageLanguageAware() {
            return this.$store?.state.geolocation.isLanguageAware;
        },

        pageLanguage() {
            return this.$store?.state.geolocation.language;
        },

        pageLocale() {
            return this.$store?.state.geolocation.finalLocale ?? LOCALE_DEFAULT;
        },

        pageLocaleMarker() {
            return this.isPageLanguageAware ? this.pageLanguage : this.pageLocale;
        },
    },
};
